<div class="dialog-container" [class]="options.size + '-dialog'" [style.width]="width">
  <div class="dialog-header" *ngIf="!options.hideHeader">
    <div class="dialog-header-title" *ngIf="title">
      <span class="header-title-icon" [class]="options.titleIconColor" *ngIf="options.titleIcon">
        <ui-svg-icon [svgIcon]="options.titleIcon!"></ui-svg-icon>
      </span>
      <span class="dialog-header-title-text">{{ title }}</span>
    </div>
    <ui-button *ngIf="!options.hideCloseButton" type="transparent" class="close-btn" icon="close" iconSize="large" (click)="onCancel()"></ui-button>
  </div>
  <div class="dialog-sub-title" *ngIf="options.subTitle">
    <span class="dialog-sub-title-text">{{ options.subTitle }}</span>
  </div>
  <div class="dialog-content">
    <ng-content></ng-content>
  </div>
  <div class="dialog-actions" *ngIf="!options.hideActions">
    <ui-button
      *ngIf="!options.hideCloseButton"
      [type]="options.cancelButtonStyle || 'secondary'"
      class="close-btn"
      testId="shared-dialog-cancel"
      [label]="options.cancelText || ('shared_dialog.cancel' | translate)"
      (click)="onCancel()"
    ></ui-button>
    <div class="dialog-actions-right">
      <ui-button
        *ngIf="options.middleText"
        [type]="options.middleButtonStyle || 'secondary'"
        testId="shared-dialog-middle"
        [icon]="options.middleIcon"
        [label]="options.middleText"
        (click)="onMiddle()"
      ></ui-button>
      <ui-button
        *ngIf="!options.customConfirmButton && !options.hideConfirmButton; else customConfirmButton"
        [type]="options.confirmButtonStyle || 'primary'"
        testId="shared-dialog-confirm"
        [label]="options.confirmText || ('shared_dialog.confirm' | translate)"
        [icon]="options.confirmIcon"
        [iconPosition]="options.confirmIconPosition || 'end'"
        [isLoading]="options.confirmLoading!"
        [disabled]="options.confirmDisabled!"
        (click)="onConfirm()"
      >
      </ui-button>
      <ng-template #customConfirmButton>
        <ng-content select="[customConfirm]"></ng-content>
      </ng-template>
    </div>
  </div>
</div>
